import React from 'react';
import { Tooltip as MuiTooltip } from 'components';

// eslint-disable-next-line react/function-component-definition
export default function RootTooltip(props) {
  return <MuiTooltip {...props} />;
}
